export const TYPES = {
  // Helpers
  Utils: Symbol.for('Utils'),
  AppConfig: Symbol.for('AppConfig'),
  AuthHelper: Symbol.for('AuthHelper'),
  AdeccoAdAuthHelper: Symbol.for('AdeccoAdAuthHelper'),
  FiscalCodeValidationITHelper: Symbol.for('FiscalCodeValidationITHelper'),

  // Context
  TenantContext: Symbol.for('TenantContext'),
  UploadDocumentContex: Symbol.for('UploadDocumentContex'),

  // Libs
  AamBackendApi: Symbol.for('AamBackendApi'),
  GoogleMapsApi: Symbol.for('GoogleMapsApi'),
  Logger: Symbol.for('Logger'),
};
